(function () {
  'use strict';

  var BRL = null;
  function fmtBRL(cents) {
    if (BRL === null) {
      try {
        BRL = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
        });
      } catch (e) {
        BRL = false;
      }
    }
    var value = cents / 100;
    if (BRL) return BRL.format(value);
    return 'R$ ' + value.toFixed(2).replace('.', ',');
  }

  function getUnitCents(qiEl) {
    return parseInt(qiEl.getAttribute('data-tiger-unit-price-cents'), 10);
  }

  function setUnitCents(qiEl, cents) {
    qiEl.setAttribute('data-tiger-unit-price-cents', String(cents));
  }

  function getTarget(qiEl) {
    var targetId = qiEl.getAttribute('data-tiger-subtotal-target');
    return targetId ? document.getElementById(targetId) : null;
  }

  function updateMainPrice(qty, unitCents) {
    var totalCents = qty * unitCents;
    var formatted = fmtBRL(totalCents);

    // Selectors for Dawn's main price display
    document.querySelectorAll('.price .price-item--regular, .price .price-item--sale').forEach(function (el) {
      // Avoid updating the unit price display inside the tiger-min-purchase block
      if (!el.closest('.tiger-min-purchase')) {
        el.textContent = formatted;
      }
    });

    updatePriceExtras(totalCents, qty);
  }

  function updatePriceExtras(totalCents, qty) {
    var root = document.querySelector('.vh-price-shipping');
    if (!root) return;

    var maxInstallments = parseInt(root.getAttribute('data-vh-max-installments'), 10) || 3;
    var pixPct = parseInt(root.getAttribute('data-vh-pix-pct'), 10) || 0;

    var installmentEl = root.querySelector('[data-vh-installment-amount]');
    if (installmentEl && maxInstallments > 1) {
      var installmentCents = Math.floor(totalCents / maxInstallments);
      installmentEl.textContent = maxInstallments + 'x de ' + fmtBRL(installmentCents);
    }

    var pixEl = root.querySelector('[data-vh-pix-amount]');
    if (pixEl && pixPct > 0) {
      var pixDiscount = Math.floor((totalCents * pixPct) / 100);
      pixEl.textContent = fmtBRL(totalCents - pixDiscount);
    }

    if (qty) root.setAttribute('data-vh-display-qty', String(qty));
  }

  function updateUnitPriceDisplay(qiEl, cents) {
    var target = getTarget(qiEl);
    if (!target) return;
    var formatted = fmtBRL(cents);
    var unitEl = target.querySelector('.tiger-min-purchase__unit');
    if (unitEl) unitEl.textContent = formatted + ' / unidade';
    var unitFormulaEl = target.querySelector('.tiger-min-purchase__unit-price');
    if (unitFormulaEl) unitFormulaEl.textContent = formatted;
  }

  function updateSubtotal(qiEl, qty) {
    var unitCents = getUnitCents(qiEl);
    var target = getTarget(qiEl);
    if (!unitCents || !target) return;
    
    var qtyEl = target.querySelector('[data-tiger-subtotal-qty]');
    var totalEl = target.querySelector('[data-tiger-subtotal-total]');
    if (qtyEl) qtyEl.textContent = qty;
    if (totalEl) totalEl.textContent = fmtBRL(unitCents * qty);

    updateMainPrice(qty, unitCents);
  }

  function clampToMin(input, qiEl) {
    var min = parseInt(qiEl.getAttribute('data-tiger-min'), 10) || parseInt(input.getAttribute('data-min'), 10) || 1;
    var current = parseInt(input.value, 10);
    var changed = false;
    
    if (isNaN(current) || current < min) {
      input.value = min;
      changed = true;
    }
    
    updateSubtotal(qiEl, parseInt(input.value, 10));
    
    if (changed) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return changed;
  }

  function wireVariantSubscription(qiEl) {
    if (qiEl.dataset.tigerVariantWired === '1') return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    qiEl.dataset.tigerVariantWired = '1';

    var mySectionId = qiEl.getAttribute('data-section');
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || event.data.sectionId !== mySectionId) return;
      var variant = event.data.variant;
      if (!variant || typeof variant.price !== 'number') return;
      if (!qiEl.isConnected) return;

      setUnitCents(qiEl, variant.price);
      updateUnitPriceDisplay(qiEl, variant.price);

      var input = qiEl.querySelector('input[type="number"][name="quantity"]');
      var qty = input ? parseInt(input.value, 10) : NaN;
      if (isNaN(qty)) qty = parseInt(qiEl.getAttribute('data-tiger-min'), 10) || 1;

      // Defer so vh-price-extras can replace installment HTML first, then we
      // scale parcels/PIX to the current qty (not just the section minimum).
      window.setTimeout(function () {
        if (!qiEl.isConnected) return;
        updateSubtotal(qiEl, qty);
      }, 0);
    });
  }

  function wireQuantityInput(qiEl) {
    if (qiEl.dataset.tigerMinWired === '1') return;
    qiEl.dataset.tigerMinWired = '1';

    var input = qiEl.querySelector('input[type="number"][name="quantity"]');
    if (!input) return;
    
    var min = parseInt(qiEl.getAttribute('data-tiger-min'), 10) || parseInt(input.getAttribute('data-min'), 10) || 1;

    // Force initial value if it's below min
    if (parseInt(input.value, 10) < min) {
      input.value = min;
    }

    var minusBtn = qiEl.querySelector('button[name="minus"]');
    if (minusBtn) {
      minusBtn.addEventListener(
        'click',
        function (e) {
          var current = parseInt(input.value, 10);
          if (!isNaN(current) && current <= min) {
            e.preventDefault();
            e.stopImmediatePropagation();
            input.value = min;
            updateSubtotal(qiEl, min);
          }
        },
        true
      );
    }

    var syncFromInput = function () {
      var v = parseInt(input.value, 10);
      if (!isNaN(v)) updateSubtotal(qiEl, v);
    };

    input.addEventListener('input', syncFromInput);
    input.addEventListener('change', function () {
      clampToMin(input, qiEl);
    });
    input.addEventListener('blur', function () {
      clampToMin(input, qiEl);
    });

    var formId = input.getAttribute('form');
    var form = formId ? document.getElementById(formId) : input.closest('form');
    if (form && form.dataset.tigerMinFormWired !== '1') {
      form.dataset.tigerMinFormWired = '1';
      form.addEventListener(
        'submit',
        function () {
          clampToMin(input, qiEl);
        },
        true
      );
    }

    wireVariantSubscription(qiEl);

    // Initial sync
    clampToMin(input, qiEl);
  }

  function init() {
    document
      .querySelectorAll('quantity-input[data-tiger-min]')
      .forEach(wireQuantityInput);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
